import { QueryFactory } from "../../../../Common";
export const QGetOpenBetsInfo = QueryFactory("GetOpenBetsInfo");
//# sourceMappingURL=QGetOpenBetsInfo.js.map